import React from 'react'
import { Box, Autocomplete } from '@material-ui/core'
import { CoreTextField } from '../core'
import { languages } from 'src/model/languages'

export default function CountrySelect(props) {
  const { languageSelection, setLanguageSelection, label } = props
  const languageOptions = languages

  const textFieldLabel = label || 'Choose language'
  return (
    <Autocomplete
      id="country-select-demo"
      sx={{
        width: '100%',
        borderRadius: '6px',
      }}
      options={languageOptions}
      autoHighlight
      getOptionLabel={option => option.name}
      renderOption={(props, option) => (
        <Box
          component="li"
          sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
          {...props}
        >
          {option.name}
        </Box>
      )}
      renderInput={params => (
        <CoreTextField {...params} label={textFieldLabel} />
      )}
      value={languageSelection}
      onChange={(event, newValue) => {
        setLanguageSelection(newValue)
      }}
    />
  )
}
